<template>
    <div v-show="weixinShow" style="background-image: url('../../assets/image/webg.png');background-repeat: no-repeat;background-size: 100% 100%;width: 100%; height: 100%;"></div>
</template>

<script type="text/babel">
export default {
  data () {
    return {
      params: this.$route.params,
      weixinShow: false
    }
  },
  methods: {
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
      this.weixinShow = true
    } else {
      window.location.href = this.$route.query.url
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/views/template1/WeixinPay.vue